import { Divider, Flex, Stack, Text } from '@chakra-ui/react';

import DOMPurify from 'dompurify';
import React from 'react';

export const ViewTermsAndConditions = ({ terms_and_conditions } : { terms_and_conditions?: Array<string> | any;  }) => {

    const terms = terms_and_conditions[terms_and_conditions?.length - 1] ?? '<p></p>';

    const createMarkup = (html: string | null | any) => {
        return {
            __html: DOMPurify.sanitize(html)
        };
    };
    
    return (
        <>
            <Flex style={{ width: '-webkit-fill-available' }}>
                <Stack bg={'#ffffff'} p={4} borderRadius={'md'} mt={4} style={{ width: '-webkit-fill-available' }}>
                    <Text fontSize={'lg'} fontWeight={'bold'}>Latest Terms and conditions.</Text>
                    <Divider />
                    <div
                        style={{
                            padding: '1rem',
                            marginTop: '1rem'
                        }}
                        dangerouslySetInnerHTML={createMarkup(terms)}>
                    </div>
                </Stack>
            </Flex>
        </>
    );
};